/* devicesListRenderer.js */

"use strict";
// const {get} = require("lodash");
const EntityGrid = require("@gluenetworks/entity_grid_gl").Grid;
const ButtonControl = require("@gluenetworks/steve_ui_core").Control.Action.Button;

class DevicesListRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("devices-list-view-gl");
        this._rootElem.component = this._model;
        this.title = document.createElement("h2");
        this._message = document.createElement("h4");
        this._copyBtn = new ButtonControl({
            label: "Copy",
            darkTheme: true,
            class: "additive",
            disabled: true,
        });

        this._cancelBtn = new ButtonControl({
            label: "Cancel",
            darkTheme: true,
        });

        this._registerEventListeners();
    }

    _registerEventListeners() {
        this._copyBtn.on(
            "UserClick",
            (this._copyButtonClicked = this._copyButtonClicked.bind(this))
        );
        this._cancelBtn.on(
            "UserClick",
            (this._cancelButtonClicked = this._cancelButtonClicked.bind(this))
        );
    }

    _registerGridListeners() {
        this._deviceEntityGrid.on(
            "UserSelectedRows",
            (this._onGridUserSelectedRows = this._onGridUserSelectedRows.bind(this))
        );
    }

    _unregisterEventListeners() {
        this._copyBtn.removeListener("UserClick", this._copyButtonClicked);
    }

    _unregisterGridListeners() {
        if (this._deviceEntityGrid) {
            this._deviceEntityGrid.removeListener("UserSelectedRows", this._onGridUserSelectedRows);
        }
    }

    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }

    async shutdown() {
        this._unregisterEventListeners();
        this._unregisterGridListeners();

        if (this._deviceEntityGrid) {
            await this._deviceEntityGrid.shutdown();
        }
        this._model = undefined;
        this._rootElem.remove();
        this._rootElem = undefined;
        this._deviceEntityGrid = undefined;
        this.title = undefined;
        this._copyBtn = undefined;

        return Promise.resolve();
    }

    async render() {
        await this._model.whenModelIsReady();
        const filterComponent = document.createElement("div");

        if (this._model._hasDiscoveredDevices) {
            return this._model._modalUserFeedback.displayError({
                title: `Unsupported Device Selection`,
                errorMsg:
                    "All selected devices must be in an undiscovered state to proceed. Please refine your selection and try again.",
                errorCode: "",
            });
        }

        if (this._model._multipleCombos) {
            return this._model._modalUserFeedback.displayError({
                title: `Unsupported Device Selection`,
                errorMsg:
                    "All selected devices must have the same xDome Manufacturer, Model, and Device Type to proceed with copying values. Please refine your selection and try again.",
                errorCode: "",
            });
        }

        this.title.innerText = "Copy From - Source Device Selection";
        this._message.innerText =
            "Select a source device from which to copy the offline discovery property values.";
        this._rootElem.append(this.title);
        this._rootElem.append(this._message);
        this._rootElem.append(filterComponent);

        this._deviceEntityGrid = new EntityGrid({
            gridKey: this._model._gridKey,
            logger: this._logger,
            singleSelect: true,
            columns: this._model.columns,
            pagingFeed: this._model._pagingDeviceFeed,
            showHeader: true,
            filterComponent: filterComponent,
            modalUserFeedback: this._model._modalUserFeedback,
        });

        this._deviceEntityGrid.renderer._emptyMessage.innerText = this._model._noDevicesMessage;

        this._registerGridListeners();

        this._rootElem.append(this._deviceEntityGrid._renderer._rootElem);

        const btnContainer = document.createElement("div");
        btnContainer.className = "copy-button-container";

        btnContainer.appendChild(this._cancelBtn.renderer._rootElem);
        btnContainer.appendChild(this._copyBtn._renderer._rootElem);

        this._rootElem.append(btnContainer);

        return Promise.resolve();
    }

    async _copyButtonClicked() {
        const selectedEntity = this._deviceEntityGrid.getEntity(
            this._deviceEntityGrid.getSelectedRows()
        );

        await this._model._copyDeviceProperties(selectedEntity.getId());
    }

    _cancelButtonClicked() {
        this._model.cancelAction();
    }

    _onGridUserSelectedRows() {
        if (this._deviceEntityGrid.getSelectedRows().length > 0) {
            this._copyBtn.setDisabled(false);
        } else {
            this._copyBtn.setDisabled(true);
        }
    }
}

module.exports = DevicesListRenderer;
